import type { DialogV2Props } from '@withjoy/joykit';
import { drawerOverrides } from '@shared/components/ResponsiveDialog/ResponsiveDialog.styles';

export const dialogOverrides: NonNullable<DialogV2Props['overrides']> = {
  Content: { props: { width: ['100%', '375px'] } },
  Body: { props: { paddingX: 6, paddingY: 8, paddingBottom: 7 } },
};

export const drawerOverridesStyles: NonNullable<DialogV2Props['overrides']> = {
  ...drawerOverrides,
  Content: {
    props: {
      ...drawerOverrides.Content?.props,
      boxShadow: '0px -7px 16px -8px rgba(0, 0, 0, 0.3), 0px -10px 27px -5px rgba(44, 41, 37, 0.25)',
    },
  },
  Body: { props: { ...drawerOverrides.Body?.props, paddingY: 8 } },
};
